/**
 * Feature flag for Projects v1.
 *
 * GA'd: defaults to ON for everyone. Treated as a kill-switch — only an
 * explicit opt-out disables it:
 *   - Build-time: `VITE_PROJECTS_V1=false` in the environment.
 *   - Runtime: `localStorage.setItem('projects_v1', 'false')`.
 *
 * Any other value (unset, 'true', etc.) keeps the new Projects UI enabled.
 *
 * Kept dead-simple — the rollout plan called out that we should NOT add
 * a flag service for this. Direct read, no React Context, no providers.
 * Phase 4 of the rollout deletes this file when the kill-switch is retired.
 */
export function isProjectsV1Enabled(): boolean {
  try {
    if (import.meta.env.VITE_PROJECTS_V1 === 'false') return false;
    if (typeof window !== 'undefined' &&
        window.localStorage?.getItem('projects_v1') === 'false') return false;
  } catch {
    // localStorage can throw in private mode — fall through to enabled.
  }
  return true;
}
